import { useCallback } from 'react';
import { useContentDetailsDataProvider } from '../providers/ContentDetailsDataProvider';
const useUpdateContentObject = () => {
  const {
    setContentObject
  } = useContentDetailsDataProvider();
  const updateContentObject = useCallback(updatedContentObjectOrObjects => {
    const updatedContentObject = Array.isArray(updatedContentObjectOrObjects) ? updatedContentObjectOrObjects[0] : updatedContentObjectOrObjects;
    setContentObject(updatedContentObject);
  }, [setContentObject]);
  return {
    updateContentObject
  };
};
export default useUpdateContentObject;